import styles from "./Disclaimer.module.css";

interface DisclaimerProps {
  disclaimerText: string;
}

const parseDisclaimer = (text: string) => {
  const regex = /<a\s+href=['"]([^'"]+)['"](?:\s+target=['"]?([^'"\s>]+)['"]?)?\s*>(.*?)<\/a>/i;
  const match = regex.exec(text);
  if (!match) return [text];

  const [fullMatch, href, target, label] = match;
  const index = match.index!;
  return [
    text.slice(0, index),
    <a
      className={styles.link}
      href={href}
      target={target}
      rel={target === "blank" ? "noopener noreferrer" : undefined}
      aria-label={`Länk till: ${label}${target === 'blank' ? ', öppnas i ny flik' : ''}`}
    >
      {label}
    </a>,
    text.slice(index + fullMatch.length),
  ];
};
  

const Disclaimer = ({ disclaimerText }: DisclaimerProps) => {
  const parsedDisclaimer = parseDisclaimer(disclaimerText); 
  return (
    <div role="region" aria-live="polite">
      <p className={styles.disclaimerText}>⚠️ {parsedDisclaimer}</p>
    </div>
  );
};

export default Disclaimer;